import React from 'react';
import DashboardLayout from '../DashboardLayout';

const WarrantyLayout: React.FC = () => {
    return (
        <DashboardLayout />
    );
};

export default WarrantyLayout;
